import React from 'react';
import { StatusBadge as CommonStatusBadge } from '../../ui/common';

interface StatusBadgeProps {
  status?: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  return <CommonStatusBadge status={status} variant="dashboard" className={className} />;
};

export default StatusBadge;
